import {Component, Input, OnInit} from '@angular/core';
import {IAbout} from 'projects/paid/src/app/components/about-us/about-us.service';

@Component({
  selector: 'app-about-us-item-business',
  templateUrl: './about-us-item-business.component.html',
  styleUrls: ['./about-us-item-business.component.scss']
})
export class AboutUsItemBusinessComponent implements OnInit {

@Input()item: IAbout;
  constructor() { }

  ngOnInit(): void {
  }

}
